<template>
  <v-container grid-list-xl fluid>
    <v-layout>
      <v-flex>
        <v-card>
          <v-card-title>
            <search-field ref="searchRef" @search="search"></search-field>
            <v-spacer></v-spacer>
            <!-- Refresh Button -->

            <refresh-button @refresh="refreshTable()"></refresh-button>

            <action-dialog
              :type="dialogType"
              :title="'DLTB Employee Details'"
              :dialog="dialogStatus"
              @closeDialog="closeDialog"
              :loading="dialogLoading"
            >
              <v-container grid-list-xs>
                <v-layout justify-center>
                  <!-- <v-flex md6> -->
                  <!-- Insert View Dialog Content BELOW-->
                  <details-container ref="detailsRef" :data="viewData" />
                  <!-- </v-flex> -->
                </v-layout>
              </v-container>
            </action-dialog>
          </v-card-title>
          <v-divider></v-divider>

          <v-container fluid class="pa-2">
            <v-layout row>
              <v-flex sm4 md4>
                <v-btn flat @click="openFilterExpansion">
                  <v-icon
                    class="mr-3"
                  >{{ openFilter ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}</v-icon>
                  <span>Filter {{ title }}</span>
                </v-btn>
              </v-flex>
              <v-flex sm8 md8></v-flex>
            </v-layout>
          </v-container>

          <v-divider></v-divider>

          <filter-panel :openFilter="openFilter">
            <v-flex md4>
              <v-select
                v-model="filterDesignation"
                :items="filterDesignations"
                label="Designation"
                solo
                clearable
              ></v-select>
            </v-flex>
          </filter-panel>

          <v-data-table :headers="headers" :items="items" hide-actions disable-initial-sort>
            <template slot="headers" slot-scope="props">
              <tr>
                <th
                  v-for="header in props.headers"
                  :key="header.text"
                  :class="[
                    'column sortable', 
                    header.value === queryParams.order ? 'active' : '', 
                    'text-xs-'+header.align
                  ]"
                  @click="header.sortable ? changeSort(header) : ''"
                >
                  {{ header.text }}
                  <v-icon
                    small
                    v-if="header.sortable"
                  >{{ header.sortNum === 1 ? "arrow_downward" : "arrow_upward"}}</v-icon>
                </th>
              </tr>
            </template>
            <template slot="items" slot-scope="props">
              <td class="text-xs-center text-uppercase">{{ props.index + 1}}</td>
              <td class="text-xs-left text-uppercase">{{ props.item.firstName }}</td>
              <td class="text-xs-left text-uppercase">{{ props.item.middleName }}</td>
              <td class="text-xs-left text-uppercase">{{ props.item.lastName }}</td>
              <td class="text-xs-center">{{ props.item.empNo }}</td>
              <td class="text-xs-center text-uppercase">{{ props.item.empType }}</td>
              <td class="text-xs-left text-uppercase">{{ props.item.designation }}</td>
              <td class="text-no-wrap text-xs-center">
                <view-button @view="openViewDialog(props.item)"></view-button>
              </td>
            </template>
          </v-data-table>
          <v-divider></v-divider>
          <v-container class="py-0" fluid>
            <v-layout wrap align-center class="pa-5"></v-layout>
          </v-container>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Services from "@/services/CompanyServices";
import DetailsContainer from "@/components/details_container/EmployeesListsDetailsContainer";

export default {
  components: {
    DetailsContainer
  },
  data: () => {
    return {
      openFilter: false,
      title: "Employees Lists",
      filterDesignations: [],
      filterDesignation: "",
      headers: [
        { text: "#", align: "center", sortable: false },
        // Add your Header BELOW
        {
          text: "First Name",
          align: "left",
          sortable: false
        },
        {
          text: "Middle Name",
          align: "left",
          sortable: false
        },
        {
          text: "Last Name",
          align: "left",
          sortable: false
        },
        {
          text: "Employee No.",
          align: "center",
          sortable: false
        },
        {
          text: "Employee Type",
          align: "center",
          sortable: false
        },
        {
          text: "Designation",
          align: "left",
          sortable: false
        },
        {
          text: "Action",
          align: "center",
          sortable: false
        }
      ],
      items: [],
      queryParams: {
        search: "",
        order: ""
      },
      dialogLoading: false,
      dialogStatus: false,
      dialogType: "",
      viewData: {}
    };
  },
  created: function() {
    this.getData();
  },
  watch: {
    filterDesignation: async function() {
      if (
        this.filterDesignation !== null &&
        this.filterDesignation !== undefined &&
        this.filterDesignation !== ""
      ) {
        this.queryParams.designation = this.filterDesignation;
        this.getData();
      } else {
        this.queryParams.designation = null;
        this.getData();
      }
    }
  },
  methods: {
    search(data) {
      this.queryParams.search = data;
      this.getData();
    },
    async getData() {
      // Start Loading
      this.$clearInfoBar();
      this.items = [];
      this.$store.dispatch("startLoading");
      try {
        // Query Data
        let response = (await Services.getDltbEmployees(this.queryParams)).data;

        // Assign the reponse data to items to be display on table

        this.items = response.data;
      } catch (error) {
        if (!error.response) {
          if (!this.$isEmpty(this.$store.state.employee)) {
            this.$infoBar({
              type: "error",
              text: "No network or server connection"
            });
          } else {
            this.$store.dispatch("dispatchUnauthorized", true);
          }
        } else {
          if (error.response.status === 403) {
            this.$store.dispatch("dispatchUnauthorized", true);
          }
        }
      }
      this.$store.dispatch("endLoading");
    },
    async openViewDialog(data) {
      this.dialogLoading = true;

      this.dialogType = "view";
      this.dialogStatus = true;

      this.viewData = await data;

      setTimeout(() => {
        this.dialogLoading = false;
      }, 600);
    },
    async closeDialog() {
      this.viewData = {};

      this.dialogType = "";
      this.dialogStatus = false;
    },
    async openFilterExpansion() {
      this.openFilter = await !this.openFilter;
      await this.setFilterDesignation();
    },
    async setFilterDesignation() {
      const items = (await Services.getDltbEmployees(this.queryParams)).data
        .data;

      let toPush = [];

      items.forEach(item => {
        toPush.push(item.designation);
      });

      let unique = [...new Set(toPush)];

      unique.forEach(designation => {
        let body = {
          text: designation.toUpperCase(),
          value: designation
        };
        this.filterDesignations.push(body);
      });
    },
    async refreshTable() {
      this.filterDesignation = await null;
      await this.getData();
    }
  }
};
</script>

<style>
</style>